import React from 'react';
import './finalCTA.css'

const JoinCTA = () => {
    return (
        <section id="free-trial-block">
            <div className="container">
                <div className="row wow fadeInUp">
                    <p data-testid="paragraph">We create your future! Let us help you bring your ideas to life.</p>
                    <a data-testid="button" href="contact.html">Request Quote</a> </div>
            </div>
        </section>
    )
}
export default JoinCTA;